// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"18":"3c9d1aee","337":"a915e90c","372":"f6cc16d2","718":"3dd3a559"}[chunkId] + ".chunk.js";
};